const Colors = {
  contentBackgroundColor: '#DCDCDC',
  sectionHeaderBlue: '#0099cc',
  primary: '#008080'
};

module.exports = Colors;



/** WEBPACK FOOTER **
 ** ./src/constants/colors.js
 **/